import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IdentityStorage } from '../auth/_models/identity.storage';
import { AbstractHttpService } from '../commons/abstract-http.service';
import { DocumentoDTO } from "../model/dto/documento.dto";
import { RequerimentoDTO } from '../model/dto/requerimento.dto';
import { RequerimentoSimplesDTO } from '../model/dto/requerimentoSimples.dto';
import { ResquerimentoForm } from '../model/requerimento-form';
import { ResponseData } from '../model/response.data';

@Injectable({
    providedIn: 'root'
})
export class RequerimentoService extends AbstractHttpService {

    private ENDPOINT_REQUERIMENTO = 'requerimento';
    private readonly ENDPOINT_BUSCAR_ID_ADVOGADO = 'buscar/advogado';
    private ENDPOINT_PAGINADO = 'paginado';

    constructor(http: HttpClient, public identityStorage: IdentityStorage,
    ) {
        super(http);
    }

    verificarRequerimento(cpfCnpj: string, precatorio: string, dataDistribuicao: string): Observable<ResponseData<RequerimentoDTO>> {
        return this.getMethod<ResponseData<RequerimentoDTO>>(`${this.ENDPOINT_REQUERIMENTO}/${cpfCnpj}/${precatorio}/${dataDistribuicao}`);
    }

    salvarDocumentos(requerimento, documentos: DocumentoDTO[]): Observable<ResponseData<RequerimentoDTO>> {
        const formData = new FormData();
        formData.append('requerimento', JSON.stringify(requerimento));
        this.setarFormSave(documentos, formData);
        return this.postWithFormData<ResponseData<RequerimentoDTO>>(this.ENDPOINT_REQUERIMENTO, formData);
    }

    editarDocumentos(requerimento, documentos: DocumentoDTO[]): Observable<ResponseData<RequerimentoDTO>> {
        const formData = new FormData();
        formData.append('requerimento', JSON.stringify(requerimento));
        this.setarFormEdit(documentos, formData);
        return this.putWithFormData<ResponseData<RequerimentoDTO>>(this.ENDPOINT_REQUERIMENTO, formData, new Headers({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.identityStorage.getIdentity().userName}`
        }));
    }

    buscarLista(request: ResquerimentoForm) {
        return this.getMethod<any>(`${this.ENDPOINT_REQUERIMENTO}/${this.ENDPOINT_PAGINADO}`, request);
    }

    buscarPorId(idRequerimento: number): Observable<ResponseData<RequerimentoDTO>> {
        return this.getMethod<ResponseData<RequerimentoDTO>>(`${this.ENDPOINT_REQUERIMENTO}/buscar/${idRequerimento}`);
    }
    pdfPorId(idRequerimento: number): Observable<ResponseData<RequerimentoDTO>> {
        return this.getMethod<ResponseData<RequerimentoDTO>>(`${this.ENDPOINT_REQUERIMENTO}/download/${idRequerimento}`);
    }

    buscarPorIdAdvogado(idAdvogado: number): Observable<ResponseData<RequerimentoSimplesDTO[]>> {
        return this.getMethod<ResponseData<RequerimentoSimplesDTO[]>>(`${this.ENDPOINT_REQUERIMENTO}/${this.ENDPOINT_BUSCAR_ID_ADVOGADO}/${idAdvogado}`);
    }

    private setarFormSave(documentos: DocumentoDTO[], formData: FormData) {
        documentos.forEach(doc => {
            formData.append('nomeArquivos', doc.nomeArquivo);
            formData.append('tpDocumento', doc.tipoDocumento.id.toString());
            formData.append('descricao', doc.descricao === undefined ? '' : doc.descricao);
            formData.append('file', doc.arquivo);
        });

    }

    private setarFormEdit(documentos: DocumentoDTO[], formData: FormData) {
        documentos.forEach(doc => {
            formData.append('nomeArquivos', doc.nomeArquivo);
            formData.append('file', doc.arquivo)
            if (doc.id) {
                formData.append('id', doc.id.toString());
            }else{
                formData.append('id', "");
            }
            formData.append('tpDocumento', doc.tipoDocumento ? doc.tipoDocumento.id.toString() : '');
            formData.append('descricao', doc.descricao === undefined ? '' : doc.descricao);
        });
    }
}
